module.exports = __webpack_public_path__ + "site/img/50.7226b598.jpg";